
import React from 'react';

export function getCoords(event, svgCoord) {
    const { clientX, clientY } = event;
    const { top, left } = svgCoord;

    return { x: clientX - left, y: clientY - top };
}

export function getRelativeCoordinatesForObjList(obj_list, svgCoord) {
    return obj_list.map((obj_info) => {
        return getRelativeCoordinatesForObj(obj_info, svgCoord);
    });
}

export function getRelativeCoordinatesForObj(obj_info, svgCoord) {
    const { width, height } = svgCoord;

    return {
        ...obj_info,
        xPosition: (obj_info.xPosition / width  * 100),
        yPosition: (obj_info.yPosition / height * 100),
        xStart:    (obj_info.xStart    / width  * 100),
        yStart:    (obj_info.yStart    / height * 100),
        xEnd:      (obj_info.xEnd      / width  * 100),
        yEnd:      (obj_info.yEnd      / height * 100),
    }
}

export function parseRelativeCoordinatesForObjList(obj_list, svgCoord) {
    return obj_list.map((obj_info) => {
        return parseRelativeCoordinatesForObj(obj_info, svgCoord);
    });
}

export function parseRelativeCoordinatesForObj(obj_info, svgCoord) {
    const { width, height } = svgCoord;

    return {
        ...obj_info,
        xPosition: (obj_info.xPosition * width  / 100),
        yPosition: (obj_info.yPosition * height / 100),
        xStart:    (obj_info.xStart    * width  / 100),
        yStart:    (obj_info.yStart    * height / 100),
        xEnd:      (obj_info.xEnd      * width  / 100),
        yEnd:      (obj_info.yEnd      * height / 100),
    }
}

export function renderRectangle(obj_info, handleMouseDownObj=()=>{}, handleMouseUpObj=()=>{}) {
    let x, y, w, h;

    if (obj_info.xStart < obj_info.xEnd) {
        x = obj_info.xStart;
        w = obj_info.xEnd - obj_info.xStart;
    } else {
        x = obj_info.xEnd;
        w = obj_info.xStart - obj_info.xEnd;
    }

    if (obj_info.yStart < obj_info.yEnd) {
        y = obj_info.yStart;
        h = obj_info.yEnd - obj_info.yStart;
    } else {
        y = obj_info.yEnd;
        h = obj_info.yStart - obj_info.yEnd;
    }

    const size = Math.min(w, h);

    return (
        <rect
            key           = {obj_info.id}
            x             = {x}
            y             = {y}
            width         = {obj_info.locked ? size : w}
            height        = {obj_info.locked ? size : h}
            fill          = {obj_info.bg}
            fillOpacity   = {0}
            stroke        = {obj_info.bg}
            strokeOpacity = {0.8}
            onMouseDown   = {(event) => handleMouseDownObj(event, obj_info)}
            onMouseUp     = {(event) => handleMouseUpObj(event, obj_info)}
        />
    );
}

export function renderCircle(obj_info, handleMouseDownObj=()=>{}, handleMouseUpObj=()=>{}) {
    let x, y, w, h;

    if (obj_info.xStart < obj_info.xEnd) {
        x = obj_info.xStart;
        w = obj_info.xEnd - obj_info.xStart;
    } else {
        x = obj_info.xEnd;
        w = obj_info.xStart - obj_info.xEnd;
    }

    if (obj_info.yStart < obj_info.yEnd) {
        y = obj_info.yStart;
        h = obj_info.yEnd - obj_info.yStart;
    } else {
        y = obj_info.yEnd;
        h = obj_info.yStart - obj_info.yEnd;
    }

    const r = Math.min(h / 2, w / 2);
    const rx = obj_info.locked ? r : w / 2;
    const ry = obj_info.locked ? r : h / 2;

    return (
        <ellipse
            key           = {obj_info.id}
            cx            = {x + rx}
            cy            = {y + ry}
            rx            = {rx}
            ry            = {ry}
            fill          = {obj_info.bg}
            fillOpacity   = {0}
            stroke        = {obj_info.bg}
            strokeOpacity = {0.8}
            onMouseDown   = {(event) => handleMouseDownObj(event, obj_info)}
            onMouseUp     = {(event) => handleMouseUpObj(event, obj_info)}
        />
    );
}

export function renderCross(obj_info) {
    if (!obj_info) return null;
    const line_length = 6;
    const x = obj_info.xPosition;
    const y = obj_info.yPosition;
    
    const line1StartX = x - line_length;
    const line1StartY = y - line_length;
    const line1EndX   = x + line_length;
    const line1EndY   = y + line_length;

    const line2StartX = x - line_length;
    const line2StartY = y + line_length;
    const line2EndX   = x + line_length;
    const line2EndY   = y - line_length;

    return [
        <line 
            key         = {obj_info.id + "-1"}
            x1          = {line1StartX}
            x2          = {line1EndX}
            y1          = {line1StartY}
            y2          = {line1EndY}
            stroke      = "blue"
            strokeWidth = "3"
        />,
        <line
            key         = {obj_info.id + "-2"}
            x1          = {line2StartX}
            x2          = {line2EndX}
            y1          = {line2StartY}
            y2          = {line2EndY}
            stroke      = "blue"
            strokeWidth = "3"
        />
    ];
}

export function renderCanvas(obj_list, handleMouseDownObj=()=>{}, handleMouseUpObj=()=>{}) {
    let shape_list = [];
    
    obj_list.forEach(obj_info => {
        switch(obj_info.type)
        {
            case("rectangle"):
            {
                shape_list.push(renderRectangle(obj_info, handleMouseDownObj, handleMouseUpObj));
                break;
            }

            case("circle"):
            {
                shape_list.push(renderCircle(obj_info, handleMouseDownObj, handleMouseUpObj));
                break;
            }

            case("cross"):
            {
                shape_list = shape_list.concat(renderCross(obj_info));
                break;
            }

            default: {}
        }
    });

    return shape_list;
}


// WEBPACK FOOTER //
// src/main/content/quiz/components/CanvasFunctions.js